import React, { FC, Suspense, lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import Zendesk from 'react-zendesk';
import config from './config';
import { ApolloProvider } from '@apollo/client';
import client from './config/apolloClient';

import Loader from './components/Loader';
import * as routes from 'src/routes/routeUrl';
import { AuthProvider } from './provider/AuthProvider';
import { ClientAuthProvider } from './provider/ClientAuthProvider';
const PrivateRouter = lazy(() => import('./components/PrivateRouter'));
const Design = lazy(() => import('src/scenes/design'));
const LogIn = lazy(() => import('./scenes/Login'));

//Client portal
const ClientLogIn = lazy(() => import('./scenes/Login/ClientLogin/ClientLogin'));
const ClientOtp = lazy(() => import('./scenes/Login/ClientLogin/ClientOtp'));
const ClientPrivateRoute = lazy(() => import('./routes/ClientPrivateRoute'));

const Logout = lazy(() => import('./scenes/Logout'));
const ForgetPassword = lazy(() => import('./scenes/ForgetPassword'));
const PrivateRoutes = lazy(() => import('./PrivateRoute'));

const Routes: FC = () => {
  return (
    <ApolloProvider client={client}>
      <AuthProvider>
        <ClientAuthProvider>
          <Suspense fallback={<Loader />}>
            <Switch>
              {/* Design Route */}
              {(process.env.NODE_ENV !== 'production' || config?.baseUrl?.includes('dev')) && (
                <Route path={routes.DESIGN} component={Design} />
              )}

              <Route exact path={routes.CLIENT_LOGIN} component={ClientLogIn} />
              <Route exact path={routes.CLIENT_OTP} component={ClientOtp} />

              <Route exact path={routes.LOGIN} component={LogIn} />
              <Route exact path={routes.LOGOUT} component={Logout} />
              <Route exact path={routes.FORGET_PASSWORD} component={ForgetPassword} />
              <PrivateRouter path={routes.CLIENT_PORTAL} component={ClientPrivateRoute} skipPermissionCheck />
              <PrivateRouter path={routes.HOME} component={PrivateRoutes} />
            </Switch>
            {/* {config.zendeskKey && (
        <Zendesk
          defer
          zendeskKey={config.zendeskKey}
          {...setting}
          onLoaded={() => {
            ZendeskAPI('messenger:set', 'cookies', false);
          }}
        />
      )} */}
            <ToastContainer />
          </Suspense>
        </ClientAuthProvider>
      </AuthProvider>
    </ApolloProvider>
  );
};
export default Routes;
